(function () {
  'use strict';

  if ('connection' in navigator) {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
  }

  var supportsPrefetch = (function () {
    var l = document.createElement('link');
    return l.relList && l.relList.supports && l.relList.supports('prefetch');
  })();

  var prefetched = new Set();
  var inflight = 0;
  var MAX_INFLIGHT = 2;
  var MAX_PREFETCHED = 200;

  function remember(url) {
    if (prefetched.size >= MAX_PREFETCHED) {
      // Drop the oldest entry to keep the Set bounded (Set preserves insertion order).
      var oldest = prefetched.values().next().value;
      prefetched.delete(oldest);
    }
    prefetched.add(url);
  }

  function prefetch(url) {
    if (!url || prefetched.has(url) || inflight >= MAX_INFLIGHT) return;
    remember(url);
    inflight++;

    if (supportsPrefetch) {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      link.onload = link.onerror = function () { inflight = Math.max(0, inflight - 1); };
      document.head.appendChild(link);
    } else {
      fetch(url, { credentials: 'same-origin', priority: 'low' })
        .catch(function () {})
        .finally(function () { inflight = Math.max(0, inflight - 1); });
    }
  }

  function prefetchImage(url) {
    if (!url || prefetched.has(url) || inflight >= MAX_INFLIGHT) return;
    remember(url);
    inflight++;
    var img = new Image();
    img.decoding = 'async';
    img.onload = img.onerror = function () { inflight = Math.max(0, inflight - 1); };
    img.src = url;
  }

  var hoverTimers = new WeakMap();

  function onHover(e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link || !link.href) return;
    if (hoverTimers.has(link)) return;

    var t = setTimeout(function () {
      prefetch(link.href);
      var img = link.querySelector('img[srcset], img[src]');
      if (img) {
        var src = img.currentSrc || img.src;
        if (src) prefetchImage(src);
      }
    }, 65);
    hoverTimers.set(link, t);
  }

  function onLeave(e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var t = hoverTimers.get(link);
    if (t) {
      clearTimeout(t);
      hoverTimers.delete(link);
    }
  }

  function onTouchStart(e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (link && link.href) prefetch(link.href);
  }

  document.addEventListener('mouseover', onHover, { passive: true });
  document.addEventListener('mouseout', onLeave, { passive: true });
  document.addEventListener('touchstart', onTouchStart, { passive: true });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var link = entry.target;
        var img = link.querySelector('img[data-prefetch-hi]');
        if (img && img.dataset.prefetchHi) prefetchImage(img.dataset.prefetchHi);
        io.unobserve(link);
      });
    }, { rootMargin: '200px 0px' });

    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.querySelector('img')) io.observe(a);
    });
  }
})();
